import { fork, put, takeEvery, all } from 'redux-saga/effects';
import {
  CampaignControllerDtoAppDetailRequest,
  CampaignControllerDtoAppRemoveRequest,
  CampaignControllerDtoAppUpdateRequest,
  CampaignControllerDtoPlayStoreSearchRequest,
  PerplayCampaignApi,
} from '../../models/src';

import CampaignControllerDtoAppListRequest from "../../models/src/model/CampaignControllerDtoAppListRequest";
import CampaignControllerDtoCreateAppRequest from "../../models/src/model/CampaignControllerDtoCreateAppRequest";
import config from '../../../config/config';
import {
  APP_CREATE_REQUEST,
  APP_INFO_REQUEST,
  APP_INFO_UPDATE_REQUEST,
  APP_LIST_REQUEST,
  APP_PLAYSTORE_SEARCH_REQUEST,
  APP_REMOVE_REQUEST,
} from '../../constants/app/gameConstants';
import {
  setRequestStatus,
} from '../../actions/app/gameActions';
import BaseResponse from '../../models/src/model/BaseResponse';
import CampaignControllerDtoAppListResponse from '../../models/src/model/CampaignControllerDtoAppListResponse';
import CampaignControllerDtoAppDetailResponse from '../../models/src/model/CampaignControllerDtoAppDetailResponse';
import CampaignControllerDtoPlayStoreSearchResponse from '../../models/src/model/CampaignControllerDtoPlayStoreSearchResponse';
import CampaignControllerDtoAppRemoveResponse from '../../models/src/model/CampaignControllerDtoAppRemoveResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PerplayCampaignApi(config.API_CLIENT);

function* appListRequestSaga(payload) {

  console.log(payload);
  const requestData = new CampaignControllerDtoAppListRequest(
      payload.page,
      payload.pageLength,
  );
  requestData.searchString = payload.searchString || "";

  try {
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignAppListPost({ campaignControllerDtoAppListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoAppListResponse);
    console.log('요청 결과: ', data);

    // yield put(
    //   setPagenation(
    //     payload.page,
    //     payload.pageLength,
    //     data.totalCount,
    //     payload.searchString,
    //   ),
    // );
    // yield put(setAppList(data.list));

    if(data.resultCode !== 200) {
      throw Error(`Error : ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    console.log(e);
    payload.error(e);

  }
}
function* appInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoAppDetailRequest();
    requestData.appNo = payload.appNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignAppDetailPost({ campaignControllerDtoAppDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoAppDetailResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* appPlayStoreSearchRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoPlayStoreSearchRequest();
    requestData.packageName = payload.packageName;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignPlayStoreSearchPost({ campaignControllerDtoPlayStoreSearchRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoPlayStoreSearchResponse);

    if (data.resultCode !== 200) {
      throw new Error(data.resultCode);
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* appRemoveRequestSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoAppRemoveRequest(
      payload.appNo,
    );
    console.log(requestData);
    const result = yield api.apiPerplayCampaignAppRemovePost(
      { campaignControllerDtoAppRemoveRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      CampaignControllerDtoAppRemoveResponse,
    );
    console.log(data);
    yield put(setRequestStatus(data, 'success'));
  } catch (e) {
    console.log(e);
    yield put(setRequestStatus(e, 'error'));
  }
}

function* appCreateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoCreateAppRequest();
    requestData.category = payload.category;
    requestData.packageName = payload.packageName;
    requestData.title = payload.title;
    requestData.developer = payload.developer;
    requestData.profileImage = payload.profileImage;
    requestData.appUrl = payload.appUrl;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignCreateAppPost({ campaignControllerDtoCreateAppRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* appInfoUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoAppUpdateRequest();
    requestData.appNo = payload.appNo;
    requestData.category = payload.category;
    requestData.title = payload.title;
    requestData.developer = payload.developer;
    requestData.profileImage = payload.profileImage;
    requestData.distributionChannel = payload.distributionChannel;
    requestData.appUrl = payload.appUrl;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignAppUpdatePost({ campaignControllerDtoAppUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* gameRootSaga() {
  yield all([
    takeEvery(APP_LIST_REQUEST, appListRequestSaga),
    takeEvery(APP_INFO_REQUEST, appInfoRequestSaga),
    takeEvery(APP_PLAYSTORE_SEARCH_REQUEST, appPlayStoreSearchRequestSaga),
    takeEvery(APP_REMOVE_REQUEST, appRemoveRequestSaga),
    takeEvery(APP_CREATE_REQUEST, appCreateRequestSaga),
    takeEvery(APP_INFO_UPDATE_REQUEST, appInfoUpdateRequestSaga),
  ]);
}

const gameSagas = [fork(gameRootSaga)];

export default gameSagas;
